/**
 * A config containing properties for toolbar
 */
var ToolbarConfig = /** @class */ (function () {
    function ToolbarConfig() {
    }
    return ToolbarConfig;
}());
export { ToolbarConfig };
//# sourceMappingURL=toolbar-config.js.map